import React from "react";
import { FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import * as kioskApi from "components/auth/selfSignIn/services/kioskApi";

interface VisitorTypeSelectionPageProps {
  form: FormInstance;
  visitorTypes: Array<{ label: string; value: string }>;
}

const VisitorTypeSelectionPage: React.FC<VisitorTypeSelectionPageProps> = ({
  form,
  visitorTypes,
}) => {
  const { t } = useTranslation();

  const translatedVisitorTypes = visitorTypes.map((type) => {
    return {
      ...type,
      label: t(`vty_data_${type.label.toLowerCase()}`, {
        defaultValue: type.label,
      }),
    };
  });

  return (
    <div className="workflow-container">
      <OpForm
        form={form}
        layout="vertical"
        className="visitor-type-form"
        onSubmit={() => {}}
        hasError={false}
        defaultButtons={false}
      >
        <OpForm.Select
          name="visitorType"
          label={t("selfSignIn.visitorType.label")}
          placeholder={t("selfSignIn.visitorType.placeholder")}
          options={translatedVisitorTypes}
          rules={[
            { required: true, message: t("selfSignIn.visitorType.required") },
          ]}
        />
      </OpForm>
    </div>
  );
};

export default VisitorTypeSelectionPage;

// Handler function to be called by parent component
export const handleVisitorTypeSelectionNext = async (
  form: FormInstance,
  workflowByVisitorType?: any[],
  firstName?: string,
  lastName?: string,
  token?: string,
): Promise<{ type: "redFlag" | "success"; visitorTypeId?: string }> => {
  await form.validateFields();
  const values = form.getFieldsValue();

  const selectedVisitorTypeId = values.visitorType;

  // Find the selected visitor type config
  if (
    workflowByVisitorType &&
    workflowByVisitorType.length > 0 &&
    firstName &&
    lastName &&
    token
  ) {
    const visitorTypeConfig = workflowByVisitorType.find(
      (item: any) => item.visitorType?.id?.toString() === selectedVisitorTypeId,
    );

    // Check if the selected visitor type has checkRedFlag enabled
    if (visitorTypeConfig?.workflowInConfig?.checkRedFlag === 1) {
      const redFlagData = await kioskApi.checkRedFlag(
        firstName,
        lastName,
        token,
      );

      const isRedFlagged = kioskApi.isVisitorRedFlagged(
        firstName,
        lastName,
        redFlagData,
      );

      if (isRedFlagged) {
        return { type: "redFlag" };
      }
    }
  }

  return { type: "success", visitorTypeId: selectedVisitorTypeId };
};
